import { useContext } from "react";
import GlobalContext from "./GlobalDataProvider";

const useGlobalContext = () => {
    return useContext(GlobalContext);
}

export default useGlobalContext;